import { render, staticRenderFns } from "./therapy.vue?vue&type=template&id=792066b4&scoped=true&"
import script from "./therapy.vue?vue&type=script&lang=js&"
export * from "./therapy.vue?vue&type=script&lang=js&"
import style0 from "./therapy.vue?vue&type=style&index=0&id=792066b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792066b4",
  null
  
)

export default component.exports